import { all, takeEvery, select, put, call } from 'redux-saga/effects';
import actions from "./actions"
import { getVehicleConfigurationApi } from "../../services/vehicle_configuration.service";
import {ReducerType} from "../reducer.type";
import { AxiosResponse } from 'axios';
import { WorkspaceType } from '../user/user.type';

const getWorkspace = (state: ReducerType) => state.user.activeWorkspace;

export function* GET_VEHICLE_CONFIGURATION(action: {payload: any, type:string}){
    try {
        const workspace: WorkspaceType = yield select(getWorkspace);
        const response: AxiosResponse<any> = yield call(
          getVehicleConfigurationApi,
          workspace.uuid,
          action.payload.vehicleId
        );
        if (response.data){

            yield put({
                type: actions.SET_VEHICLE_CONFIGURATION,
                payload: response.data
            })
        }
    } catch (e) {
        yield put({
            type: actions.SET_VEHICLE_CONFIGURATION,
            payload: {uuid:'noConfig'}
        })
    }
}

export default function* rootSaga() {
    yield all([
        takeEvery(actions.GET_VEHICLE_CONFIGURATION, GET_VEHICLE_CONFIGURATION),
    ])
}
